module.exports = __webpack_public_path__ + "img/jujialei-18.2641685d.png";